import secureLocalStorage from "react-secure-storage";
import React, { useEffect, useState } from "react";
import Api from "../../Services/Api";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import TaskCustomFieldDate from "./TaskCustomFieldDate";
import TaskCustomFieldNumber from "./TaskCustomFieldNumber";
import TaskCustomFieldFreeText from "./TaskCustomFieldFreeText";
import TaskCustomFieldSingleDropdown from "./TaskCustomFieldSingleDropdown";
import TaskCustomFieldMultiDropdown from "./TaskCustomFieldMultiDropdown";
import { filterBy, process } from "@progress/kendo-data-query";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { toastr } from "react-redux-toastr";
import TaskStatus from "./TaskStatus";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import TaskOwner from "./TaskOwner";
import TaskAlertDescription from "./TaskAlertDescription";
import TaskAlertStakeholders from "./TaskAlertStakeholders";
import TaskDelayConsequence from "./TaskDelayConsequence";
import TaskProximityAlertDate from "./TaskProximityAlertDate";
import TaskActualCompDate from "./TaskActualCompDate";
import TaskProjectedComDate from "./TaskProjectedComDate";
import TaskOriginalCompDate from "./TaskOriginalCompDate";
import TaskPercentageCompletion from "./TaskPercentageCompletion";
import TaskPercentageOnTrack from "./TaskPercentageOnTrack";
import TaskCost from "./TaskCost";
import TaskDescription from "./TaskDescription";
import TaskTitle from "./TaskTitle";
import TaskApproved from "./TaskApproved";
import TaskEffort from "./TaskEffort";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import { CircularProgress } from "@material-ui/core";
import PriorityRank from "./PriorityRank";
import Images from "../../Assets/Images";
import { mapTree } from "@progress/kendo-react-treelist";
import { NavLink } from "react-router-dom";
import TaskRegisterFormView from "./TaskRegisterFormView";
import { useRef } from "react";
import { TaskActionExpandGrid } from "./TaskActionExpandGrid";
import GridExpandComponent from "../Tenant/Component/GridExpandCompoent";
import PersistenceTaskAction from "../Tasks/PersistenceTaskAction.json"
import TaskProgressPopup from "./TaskProgressPopup";

var selectedColumn = undefined;
var existingFilter = [];
var existingFilterV1 = [];
var masterRiskList = [];

export default function RecentlyViewedTasks(props) {
  const [customFieldsDataState, setCustomFieldsDataState] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [dropdownColumns, setDropdownColumns] = React.useState([]);
  const [updatedfield, setUpdatedField] = React.useState(0);
  const [expandedRowList, setExpandRowList] = React.useState([]);
  const [editField, setEditField] = React.useState(undefined);
  const myRef = useRef();
  const [fixedGrid, setFixedGrid] = React.useState(true);
  const [stickyClassVal, setStickClass] = React.useState("");
  
  const [filter, setFilter] = React.useState({
    logic: "and",
    filters: [],
  });
  const [dataState, setDataState] = React.useState({
    sort: [],
    take: 10, //Math.round((window.innerHeight - 250) / 35),
    skip: 0,
    group: [],
  });
  
  const reportWindowSize = () => {
    if (window.innerWidth > 768) {
      setFixedGrid(true);
      setStickClass("k-grid-content-sticky");
    } else {
      setFixedGrid(false);
      setStickClass("");
    }
  };

  window.addEventListener("resize", reportWindowSize);
  window.addEventListener("load", reportWindowSize);

  var customFieldsData = [];
  useEffect(() => {
    let id = props.taskOwnerByTenant ? props.taskOwnerByTenant?.value : null;
    initLoad(id);
  }, [props.taskOwnerByTenant]);

  const initLoad = async (id) => {
    if (customFieldsData.length == 0) {
      let res = await getCustomField();
      customFieldsData = res;
    }
    await homeTasksByOwner(id);
  };



  const riskRegistorUpdateValidation = async (Value) => {
    var flag = true;
    var msg = "";

    if (!Value.taskTitle || Value.taskTitle.trim() == "") {
      flag = false;
      msg = "The task title";
    }

    if (!flag) {
      toastr.error(msg + " are required");
    }
    return flag;
  };
  const processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  const refreshPersistence = (per) => {
    props.refreshExpandActivity(per);
  };
  const updateTaskRegisterDropDown = async (updateDate) => {
    await updateTaskRegistor(updateDate, true);
    exitEdit();
  };

  const updateTaskRegistor = async (taskObj, flag) => {
    try {
      console.log("updateDate-101", taskObj);
      setLoader(true);
      if (flag) {
        var flag1 = await riskRegistorUpdateValidation(taskObj);

        if (!flag1) {
          setLoader(false);
          return;
        }
      }

      taskObj.isClosed =
        taskObj.isClosed === "Closed" || taskObj.isClosed === true
          ? true
          : false;

      if (
        taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === false &&
        taskObj.percentageCompletion >= 100
      ) {
        taskObj.percentageCompletion = 0;
      }

      if (
        taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === false &&
        taskObj.actualCompletionDate
      ) {
        taskObj.actualCompletionDate = null;
      }

      if (taskObj.percentageCompletion >= 100) {
        taskObj.isClosed = true;
        taskObj.actualCompletionDate = new Date();
      }
      if (
        taskObj.percentageCompletion >= 100 &&
        !taskObj.actualCompletionDate
      ) {
        taskObj.isClosed = true;
        taskObj.actualCompletionDate = new Date();
      }

      if (taskObj.actualCompletionDate) {
        taskObj.isClosed = true;
      }

      if (taskObj.originalCompletionDate && !taskObj.projectedCompletionDate) {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if (taskObj.projectedCompletionDate && !taskObj.originalCompletionDate) {
        taskObj.originalCompletionDate = taskObj.projectedCompletionDate;
      }
      if (taskObj.inEdit == "originalCompletionDate") {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if (taskObj.isClosed === false) {
        taskObj.actualCompletionDate = null;
      }

      let request = {
        taskRegisterId: taskObj.taskRegisterId,
        organizationUnitId: taskObj.organizationUnitId,
        taskCustomFields: taskObj.taskCustomField
          ? [taskObj.taskCustomField]
          : [],
        isApproved:
          taskObj.isApproved === "Yes" || taskObj.isApproved === true
            ? true
            : false,
        isClosed:
          taskObj.isClosed === "Closed" || taskObj.isClosed === true
            ? true
            : false,
        taskTitle: taskObj.taskTitle?.slice(0, 30),
        taskDescription: taskObj.taskDescription,
        cost: taskObj.cost,
        effort: taskObj.effort,
        taskOwner: taskObj.ownerId
          ? { value: taskObj.ownerId, text: taskObj.taskOwnerName }
          : null,
        percentageOnTrack:
          taskObj.percentageOnTrack > 100 ? 100 : taskObj.percentageOnTrack,
        percentageCompletion:
          taskObj.percentageCompletion > 100
            ? 100
            : taskObj.percentageCompletion,

        proximityAlertDate: taskObj.proximityAlertDate
          ? moment(taskObj.proximityAlertDate).format("YYYY-MM-DD")
          : null,
        originalCompletionDate: taskObj.originalCompletionDate
          ? moment(taskObj.originalCompletionDate).format("YYYY-MM-DD")
          : null,
        projectedCompletionDate: taskObj.projectedCompletionDate
          ? moment(taskObj.projectedCompletionDate).format("YYYY-MM-DD")
          : null,
        actualCompletionDate: taskObj.actualCompletionDate
          ? moment(taskObj.actualCompletionDate).format("YYYY-MM-DD")
          : null,

        delayConsequence: taskObj.delayConsequence,
        alertStakeHolders: processInput(taskObj.alertStakeHolders),
        alertDescription: taskObj.alertDescription,
        priorityRankingId: taskObj.priorityRankingId,
        effortUnitId: taskObj.effortUnitId,
        progressComment: editField == "progressComment" ? taskObj.progressComment : null,
      };

      let response = await Api.addTaskRegisterAsync(request);
      if (response.status === 200) {
        setUpdatedField(taskObj.taskRegisterId);
        let id = props.taskOwnerByTenant
          ? props.taskOwnerByTenant?.value
          : null;
        homeTasksByOwner(id);
      } else {
        setLoader(false);
        setUpdatedField(0);
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  const onColumnReorder = async (event) => {
    try {
      if (event) {
        // const newArray=mergeAndUpdateArrays(persistenceRiskGridTemp,event.target.columnResize.columns);

        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          workstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          screenName: "HomeTask",
        };
        await Api.addTaskPersistence(req);
      } else {
        //Reset

        let req = {
          persistenceDetails: null,
          WorkstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          screenName: "Task",
        };
        await Api.addTaskPersistence(req);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const expandChange = React.useCallback(
    (dataItem) => {
      dataItem.expanded = !dataItem.expanded;
      let expandRow = expandedRowList ? expandedRowList : [];

      //scroll reset
      document
        .getElementById("DataGrid")
        .getElementsByClassName("k-grid-content")[0].scrollLeft = 0;
      //
      if (expandRow.includes(dataItem.taskRegisterId)) {
        let expanedState = expandedRowList;
        let indexValue = expanedState.findIndex(
          (item) => dataItem.taskRegisterId === item
        );
        expanedState.splice(indexValue, 1);
        expandRow = expanedState;
      } else {
        expandRow.push(dataItem.taskRegisterId);
      }
      data.map((riskReg) => {
        if (riskReg.taskRegisterId === dataItem.taskRegisterId) {
          riskReg["expanded"] = dataItem.expanded;
        }
      });

      setExpandRowList(expandRow);
      setData([...data]);
     
      masterRiskList = [...data];
    },
    [data, setData, expandedRowList, setExpandRowList]
  );
  const expandCell = (props) => (
    <GridExpandComponent {...props} expandChange={expandChange} />
  );
  const onColumnResize = async (event) => {
    if (event.end) {
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          screenName: "HomeTask",
        };
        await Api.addTaskPersistence(req);
      } catch (err) {
        console.log(err);
      }
    }
  };
  const filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      let filterData = existingFilter ? existingFilter : [];
      let filter = e.filter ? e.filter.filters : [];
      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      existingFilterV1 = [...dedupedFilters];
      existingFilter = dedupedFilters;
      const result = filterBy(masterRiskList, dedupedFilters);
      await createDynamicDropdowns(result, dedupedFilters);
      setData(result);
      setDataState({
        sort: [],
        take: 10,
        skip: 0,
        group: [],
      });
      setFilter(e.filter);
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (existingFilter) {
        let filterData = existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != selectedColumn) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          }
        });
      }

      existingFilter = exi;
      existingFilterV1 = [...exi];
      const result = filterBy(masterRiskList, exi);
      await createDynamicDropdowns(result, exi);
      setData(result);
      setDataState({
        sort: [],
        take: 10,
        skip: 0,
        group: [],
      });
      setFilter(e.filter);
    }
  };
  const filterChangeV = async (e, colname) => {
    try {
      // let exi = existingFilter ? existingFilter : existingFilterV1;
      let exi = [];

      let filterData = existingFilter ? existingFilter : existingFilterV1;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field != colname) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          });
        } else {
          if (filter2.field != colname) {
            if (!exi.includes(filter2)) {
              exi.push(filter2);
            }
          }
        }
      });

      let filter = e ? e.filters : [];
      let temp = [];
      if (filter.length > 0) {
        temp = [
          {
            filters: filter,
            logic: "or",
          },
        ];
      }
      
      // Combine filtered existing filters with new filters
      let combinedFilters = [...exi, ...temp];
      
      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];
      
      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }

      existingFilter = dedupedFilters;
      existingFilterV1 = [...dedupedFilters]; // Make sure existingFilterV1 is also updated
      
      const result = filterBy(masterRiskList, dedupedFilters);
      await createDynamicDropdowns(result, dedupedFilters);
      setData(result);

      setFilter({
        logic: "and",
        filters: dedupedFilters,
      });
      setDataState({
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        group: [],
      });
    } catch (err) {}
  };
  const clearFilter = async (e) => {
    let filter = e ? e : [];
    const result = filterBy(masterRiskList, filter);
    await createDynamicDropdowns(result, filter);
    existingFilter = filter;
    setData(result);
    setFilter({
      logic: "and",
      filters: filter,
    });
  };
  const manageCustomValues = async (updateDate) => {
    let type = getInputType(updateDate.inEdit);
    if ((type && type === "Multi Drop Down") || type === "Single Drop Down") {
      updateTaskRegistor(updateDate, false);
    } else {
      let dirtData = masterRiskList.find(
        (item) => updateDate.taskRegisterId == item.taskRegisterId
      );
      if (
        dirtData &&
        updateDate[updateDate.inEdit] == dirtData[updateDate.inEdit]
      ) {
        exitEdit();
        return;
      } else {
        updateTaskRegistor(updateDate, false);
      }
    }
  };
  const getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getCustomField(request);
      if (response.status == 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = convertStrToHash(item1.possibleValues);
          });
          if (item.inputType == "Single Drop Down") {
            let newFirstElement = {
              hashValue: "",
              id: 0,
              possibleValues: " [blank]",
            };
            item["cfPossibleValues"] = [newFirstElement].concat(
              item.cfPossibleValues
            );
            item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          } else if (item.inputType == "Multi Drop Down") {
            let newFirstElement = {
              hashValue: "",
              id: 0,
              possibleValues: " [blank]",
            };

            item["cfPossibleValues"] = [newFirstElement].concat(
              item.cfPossibleValues
            );
            item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          }
        });
        setCustomFieldsDataState(response.customFields);
        res = response.customFields;
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };
  const convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };
  const enterEdit = (dataItem, field) => {
    try {
      const dataValue = data.map((item) => ({
        ...item,
        inEdit:
          item.taskRegisterId === dataItem.taskRegisterId ? field : undefined,
      }));
      setData(dataValue);
      setEditField(field);
    } catch (err) {}
  };
  const getSelectedColumn = (col) => {
    if (col != selectedColumn) {
      selectedColumn = col;
    }
  };
  const exitEdit = () => {
    const dataValue = data.map((item) => ({ ...item, inEdit: undefined }));
    setData(dataValue);
  };

  const cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];
    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              enterEdit(dataItem, cellField);
            },
            onFocus: () => {
              enterEdit(dataItem, cellField);
            },
            tabIndex: "0",
          };

    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  const rowRender = (trElement, props) => {
    const taskrowId = updatedfield;
    const bgcolor = {
      backgroundColor: "rgba(0, 255, 76, 0.308)",
    };
    const trProps = {
      ...trElement.props,
      style: taskrowId == props.dataItem.taskRegisterId ? bgcolor : null,

      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        if (editField === "alertStakeHolders" || editField === "progressComment") {
          return;
        }
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            exitEdit();
          });
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };

    return React.cloneElement(
      trElement,
      {
        ...trProps,
      },

      trElement.props.children
    );
  };

  const itemChange = async (event) => {
    let changedValue;
    let dataValue;
    changedValue = { ...event.dataItem, [event.field]: event.value };
    dataValue = data.map((item) =>
      item.taskRegisterId === event.dataItem.taskRegisterId
        ? { ...item, [event.field]: event.value }
        : item
    );
    setData(dataValue);
    // setCurrentChangedValue((preState) => ({ ...preState, ...changedValue }));
  };

  const getGridColum = (columns) => {
    let field = columns.field;
    let title = columns.title;
    let width = columns.width;
    let currency = secureLocalStorage.getItem("currency");
    let effortUnitName = "Days";

    if (!field) {
      return;
    } else if (field === "isApproved") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          columnIndex
          cell={(props) => (
            <TaskApproved
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("isApproved")}
        />
      );
    } else if (field === "taskTitle") {
      return (
        <GridColumn
        field={field}
          title={title}
          width={width}
          resizable={false}
          reorderable={false}
          orderIndex={0}
          editable={true}
          locked={fixedGrid}
          fixedScroll={true}
          key={field}
          cell={(props) => (
            <TaskTitle
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              pageName={"home"}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={`${setClassName("taskTitle")} no-drag`}
        />
      );
    } else if (field === "taskDescription") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDescription
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskDescription")}
        />
      );
    } else if (field === "cost") {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(currency) ? title : title + " (" + currency + ")"
          }
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskCost
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("cost")}
        />
      );
    }else if (field === "approvedCost") {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(currency) ? title : title + " (" + currency + ")"
          }
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskCost
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("approvedCost")}
        />
      );
    } else if (field === "taskActionCount") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskActionCount")}
        />
      );
    } else if (field === "effort") {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(effortUnitName)
              ? title
              : title + " (" + effortUnitName + ")"
          }
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskEffort
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("effort")}
        />
      );
    }
    else if (field === "approvedEffort") {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(effortUnitName)
              ? title
              : title + " (" + effortUnitName + ")"
          }
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskEffort
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("approvedEffort")}
        />
      );
    } else if (field === "percentageOnTrack") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskPercentageOnTrack
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("percentageOnTrack")}
        />
      );
    } else if (field === "percentageCompletion") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"number"}
          cell={(props) => (
            <TaskPercentageCompletion
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("percentageCompletion")}
        />
      );
    } else if (field === "originalCompletionDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskOriginalCompDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("originalCompletionDate")}
        />
      );
    } else if (field === "projectedCompletionDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskProjectedComDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("projectedCompletionDate")}
        />
      );
    } else if (field === "actualCompletionDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskActualCompDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("actualCompletionDate")}
        />
      );
    } else if (field === "proximityAlertDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskProximityAlertDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("proximityAlertDate")}
        />
      );
    } else if (field === "delayConsequence") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("delayConsequence")}
        />
      );
    } else if (field === "alertStakeHolders") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          cell={(propstask) => (
            <TaskAlertStakeholders
              {...propstask}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              exitEdit={exitEdit}
              dropDownData={
                props.stackeHolderList ? props.stackeHolderList : []
              }
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertStakeHolders")}
        />
      );
    } else if (field === "alertDescription") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskAlertDescription
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertDescription")}
        />
      );
    } else if (field === "taskOwnerName") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(propstask) => (
            <TaskOwner
              {...propstask}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              ownerList={props.ownerList}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskOwnerName")}
        />
      );
    } else if (field === "createdDate") {
      return (
        <GridColumn
          field="createdDate"
          title="created Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdDate")}
        />
      );
    } else if (field === "createdByName") {
      return (
        <GridColumn
          field="createdByName"
          title="Created By"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdByName")}
        />
      );
    } else if (field === "updatedDate") {
      return (
        <GridColumn
          field="updatedDate"
          title="updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedDate")}
        />
      );
    } else if (field === "updatedByName") {
      return (
        <GridColumn
          field="updatedByName"
          title="Updated By"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedByName")}
        />
      );
    } else if (field === "closedDate") {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("closedDate")}
        />
      );
    } else if (field === "isClosed") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskStatus
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskOwnerName")}
        />
      );
    } else if (field === "customFields") {
      return dropdownColumns;
    } else if (field === "priorityRankingName") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(propsrank) => (
            <PriorityRank
              {...propsrank}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              priorityRankingsList={props.priorityRankingsList}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("priorityRankingName")}
        />
      );
    } else if (field === "priorityScore") {
      return (
        <GridColumn
          field={field}
          title={title}
          filter={"numeric"}
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("priorityScore")}
        />
      );
    } else if (field === "progressComment") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskProgressPopup
              {...props}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("progressComment")}
        />
      );
    } else {
      let cf = dropdownColumns.find((item) => field === item.props.field);
      if (cf) {
        // Clone the object and update width
        let newCf = {
          ...cf,
          props: {
            ...cf.props,
            width: width,
          },
        };

        return newCf;
      }
    }
  };
  const homeTasksByOwner = async (id) => {
    try {
      setLoader(true);
      let ownerId = secureLocalStorage.getItem("loginUserId");
      if (id) {
        ownerId = id;
      }
      let response = await Api.homeTasksByOwner(ownerId);
      if (response.status === 200 && response.taskRegisters) {
        response.taskRegisters.map((riskReg) => {
          if (expandedRowList.includes(riskReg.taskRegisterId)) {
            riskReg["expanded"] = true;
          } else {
            riskReg["expanded"] = false;
          }
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          //   if (workstreamRole) {
          //     riskReg["role"] = workstreamRole;
          //   }

          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });

        let filter = existingFilter ? existingFilter : [];
        await createDynamicDropdowns(response.taskRegisters, filter);
        const result = filterBy(response.taskRegisters, filter);
        setData(result);
        setLoader(false);
        masterRiskList = response.taskRegisters;
      } else {
        setData([]);
        setLoader(false);
        masterRiskList = [];
      }
    } catch (error) {
      setData([]);
      masterRiskList = [];
    }
  };
  //Custom fields
  const createDynamicDropdowns = (products, filter) => {
    let dropdownColumn = [];
    products.map((res) => {
      res.customFields &&
        res.customFields.map((item) => {
          if (dropdownColumn.length > 0) {
            if (!dropdownColumn.find((cf) => cf.fieldName == item.fieldName)) {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: getCustomFieldMasterData(item.fieldName, filter),
                inputType: getInputType(item.fieldName),
              });
            }
          } else {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: getCustomFieldMasterData(item.fieldName, filter),
              inputType: getInputType(item.fieldName),
            });
          }
        });
    });

    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp =
            res.customFields &&
            res.customFields.find((item) => item.fieldName === col.fieldName);
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val = temp.multiText;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val = temp.multiText ? parseInt(temp.multiText) : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val = temp.multiText ? new Date(temp.multiText) : undefined;
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "";
          }
        });
      });
    }
    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => (
        <GridColumn
          field={item.fieldName}
          title={item.fieldName}
          resizable={true}
          reorderable={true}
          // width={getFieldWidth(item.fieldName)}
          width={"200px"}
          cell={(props) => getCustomFieldComponent(props, products, item)}
          columnMenu={(props) => getCustomFieldColumnMenu(props, item)}
          filter={getCustomFieldFilter(item)}
          headerClassName={checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    setDropdownColumns(columnsToShow);
  };

  const getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  const getcustomfieldfilterlist = (list) => {
    var sorted_arr = list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return sorted_arr;
  };
  const stringToHashForCF = (stringArr, data) => {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    // console.log(hashArr.toString(),stringArr)
    return hashArr.toString();
  };
  const getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      getcustomfieldfilterlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={existingFilter ? existingFilter : existingFilterV1}
          filterChangeV={filterChangeV}
          clearFilter={clearFilter}
        />
      );
    } else if (item.inputType === "Single Drop Down") {
      return (
        <ColumnMenuCheckboxFilter
          {...props}
          data={masterRiskList}
          getSelectedColumn={getSelectedColumn}
        />
      );
    } else {
      return (
        <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
      );
    }
  };

  const getFieldWidth = (cellFieldName) => {
    let width = "200px";
    let res = props.persistenceTaskGrid.find(
      (item) => item.field === cellFieldName
    );
    if (res) {
      width = res.width;
    }
    return width;
  };
  const customCellEdit = (dataItem, field, riskData) => {
    try {
      let filter = existingFilter ? existingFilter : [];
      const result = filterBy(riskData, filter);
      const dataValue = result.map((item) => ({
        ...item,
        inEdit:
          item.taskRegisterId === dataItem.taskRegisterId ? field : undefined,
      }));
      createDynamicDropdowns(result, filter);
      setData(dataValue);
      setEditField(field);
    } catch (err) {}
  };
  const getCustomFieldComponent = (props, products, cfObj) => {
    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      return (
        <TaskCustomFieldMultiDropdown
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <TaskCustomFieldSingleDropdown
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <TaskCustomFieldFreeText
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <TaskCustomFieldNumber
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <TaskCustomFieldDate
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else {
      return <td></td>;
    }
  };

  const getInputType = (fieldName) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.find((item) => item.fieldName == fieldName);
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCustomFieldMasterData = (fieldName, filter) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.filter((item) => item.fieldName == fieldName);
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  const setClassName = (field) => {
    let headerClassName = "";
    if (filter && filter.filters) {
      filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  const checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };

  const checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };

  const [formEditFlag, setFormEditFlag] = React.useState(false);
  const [showFormView, setShowFormView] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [orgUnit, setOrgUnit] = React.useState({});

  const editFormView = (dataItem) => {
    try {
      console.log("dataItem", dataItem);
      setFormEditFlag(true);
      setFormData(dataItem);
      setShowFormView(true);
      let orgUnit = {};
      mapTree(props.organisationUnitList, "children", (item) => {
        if (item.unitId === dataItem.organizationUnitId) {
          orgUnit = item;
        }
        return item;
      });
      setOrgUnit(orgUnit);
      if (myRef && myRef.current) {
        myRef.current.loadEditmode(dataItem);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addTaskDataFromForm = (flag, formData) => {
    try {
      let id = props.taskOwnerByTenant ? props.taskOwnerByTenant?.value : null;
      initLoad(id);
    } catch (err) {
      console.error(err);
    }
  };

  const closeRiskFormView = () => {
    setShowFormView(false);
    setFormEditFlag(false);
    setFormData({});
  };
  const actionButtons = (event) => {
    let eventData = event;
    return (
      <td className={stickyClassVal} style={{ left: "42px", right: "0px" }}>
        <ul className="actionIcon">
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => editFormView(eventData.dataItem)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/taskregisterdocs/${
                  eventData.dataItem.taskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
        </ul>
      </td>
    );
  };
  return (
    <div id="home-riskMitigation">
      {loader ? (
        <span className="MatTableSpinner">
          <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
        </span>
      ) : null}
      {/* Task Form View */}
      <TaskRegisterFormView
        formEditFlag={formEditFlag}
        formData={formData}
        showFormView={showFormView}
        orgUnit={orgUnit}
        closeRiskFormView={closeRiskFormView}
        addRiskDataFromForm={addTaskDataFromForm}
        dropDownData={props.stackeHolderList ? props.stackeHolderList : []}
        ownerListForRisk={props.ownerList}
        priorityRankingsList={props.priorityRankingsList}
        customFieldsData={
          customFieldsData.length > 0 ? customFieldsData : customFieldsDataState
        }
        {...props}
        ref={myRef}
      />
      <Grid
        //   ref={gridRef}
        data={process(data, dataState)}
        reorderable={data.length == 0 ? false : true}
        resizable={data.length == 0 ? false : true}
        pageable={true}
        onItemChange={itemChange}
        cellRender={cellRender}
        rowRender={rowRender}
        editField="inEdit"
        groupable={false}
        expandField="expanded"
        detail={(propsts) => (
          <TaskActionExpandGrid
            {...propsts}
            getRiskRegistorList={addTaskDataFromForm}
            refreshRisk={addTaskDataFromForm}
            ownerListForMitigation={props.ownerList}
            stackeHolderList={
              props.stackeHolderList ? props.stackeHolderList : []
            }
            priorityRankingsList={props.priorityRankingsList}
            persistenceActionGrid={props.persistenceActivityExpandGrid}
            orgUnit={orgUnit}
            refreshPersistence={refreshPersistence}
            customFieldsmaster={
              customFieldsData.length > 0 ? customFieldsData : customFieldsDataState
            }
            organisationUnitList={props.organisationUnitList}
            pageName={"Home"}
          />
        )}
        {...dataState}
        onDataStateChange={(e) => {
          setDataState(e.dataState);
        }}
        sortable={
          data.length == 0
            ? false
            : {
                allowUnsort: true,
                mode: "multiple",
              }
        }
        onFilterChange={filterChangeExisting}
        onColumnReorder={onColumnReorder}
        onColumnResize={onColumnResize}
          filter={filter}
      >
        <GridColumn
          // locked={fixedGrid}
          cell={expandCell}
          width="42px"
          title=""
          minResizableWidth={42}
          orderIndex={0}
          resizable={false}
          reorderable={false}
          headerClassName="no-drag"
        />
        <GridColumn
          cell={actionButtons}
          width="100px"
          filterable={false}
          orderIndex={0}
          resizable={false}
          reorderable={false}
          headerClassName="no-drag"
          // locked={fixedGrid}
        />
        <GridColumn
          locked={true}
          field="organizationUnitName"
          title="Workstream"
          width="180px"
          editable={false}
          orderIndex={0}
          minResizableWidth={100}
          reorderable={false}
          resizable={false}
          headerClassName={`${setClassName("organizationUnitName")} no-drag`}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
        />
        <GridColumn
          locked={true}
          field="taskNumber"
          title="Task Number"
          width="120px"
          editable={false}
          orderIndex={0}
          minResizableWidth={100}
          resizable={false}
          reorderable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={`${setClassName("taskNumber")} no-drag`}
        />

        {props.persistenceTaskGrid.map((columns) => getGridColum(columns))}
      </Grid>
    </div>
  );
}
